import { ConnectDragSource, ConnectDropTarget } from "react-dnd";
import { Ref, RefCallback } from "react";

/**
 * Type-safe ref for react-dnd drag connectors
 */
export function dragRef<T extends HTMLElement>(connector: ConnectDragSource): Ref<T> {
	return toRefCallback<T>(connector);
}

/**
 * Type-safe ref for react-dnd drop connectors
 */
export function dropRef<T extends HTMLElement>(connector: ConnectDropTarget): Ref<T> {
	return toRefCallback<T>(connector);
}

/**
 * Wraps a react-dnd connector (drag/drop ref) to be compatible with React 19's ref types.
 *
 * In React 19, ref callbacks must return void or a cleanup function, but react-dnd's
 * ConnectDragSource and ConnectDropTarget return ReactElement | null when used as
 * element wrappers. This utility ensures they work correctly as ref callbacks.
 */
function toRefCallback<T extends HTMLElement>(connector: ConnectDragSource | ConnectDropTarget): RefCallback<T> {
	return (instance: T | null) => {
		connector(instance);
	};
}
